import { ListUsersForSystemResponse } from '@wavingroup/aqora-v2-crate/wavin/aqora/v2/aqora_service_pb';
import { aqoraClient } from '~/services/api/aqora-client';

export const listSystemUsers = (
  systemName: string,
): Promise<ListUsersForSystemResponse> =>
  aqoraClient.listUsersForSystem({
    systemName,
  });
